<h4 class="text-lg font-semibold mb-4">
  {{ 'provider.tender.confirmation.rejectionReasonTitle' | transloco }}
</h4>

<div class="grid grid-cols-1 md:grid-cols-3 gap-4">
  <app-form-field-select
    id="tenderRejectionReason"
    fieldName="tenderRejectionReasonId"
    [options]="rejectionReasons()"
    [showClear]="false"
  ></app-form-field-select>
</div>
